import { render, staticRenderFns } from "./MyCompany.vue?vue&type=template&id=2e657387"
import script from "./MyCompany.vue?vue&type=script&lang=js"
export * from "./MyCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports